<template>
    <Table border :columns="fileSchemaList" :data="attachments">
        <template slot-scope="{ row }" slot="action">
            <Button type="success" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
        </template>
    </Table>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { FileSchemaList } from "@/util/tableTitle"

export default {
    name: "FileDocument",
    created() {
    },
    props: {
        attachments: {
            type: Array,
            default: () => [],
        }
    },
    methods: {
        ...mapGetters(["getUserProfile", "getLanguage"]),
        ...mapActions(["toggleLoading"]),
        downloadAttachment(row) {
            this.$downloadAttachment(this, row.id)
        },
    },
    data() {
        return {
            fileSchemaList: FileSchemaList(this)
        }
    }
}
</script>

<style scoped></style>